<template>
  <div></div>
</template>
<script>
export default {
  name: 'Spotify',
  dependencies: ['DATA'],
  props: ['login'],
  data () {
    let playlist = this.DATA.configs.radio.playlist.split('spotify:user:')[1].split(':playlist:')

    return {
      playlist: {},
      playlistUrl: `https://open.spotify.com/user/${playlist[0]}/playlist/${playlist[1]}`,
      playlistUri: this.DATA.configs.radio.playlist,
      playlistUser: playlist[0],
      playlistId: playlist[1],
      index: null
    }
  },
  methods: {
    mountPlayer () {
      let spotifyAccessToken = this.$storage.get('spotifyAccessToken')
      if (spotifyAccessToken === null || window.player) {
        return
      }
      window.player = new window.Spotify.Player({
        name: this.DATA.configs.radio.title,
        getOAuthToken: cb => {
          cb(spotifyAccessToken)
        }
      })

      // Error handling
      window.player.addListener('initialization_error', ({ message }) => {
        console.error(message)
        this.$bus.$emit('spotify-player-error', message)
      })

      window.player.addListener('authentication_error', ({ message }) => {
        console.error(message)
        this.$bus.$emit('spotify-player-error', message)
      })

      window.player.addListener('account_error', ({ message }) => {
        console.error(message)
        this.$bus.$emit('spotify-player-error', message)
      })

      window.player.addListener('playback_error', ({ message }) => {
        console.error(message)
        this.$bus.$emit('spotify-player-error', message)
      })

      window.player.addListener('not_ready', (device) => {
        console.log('Device ID has gone offline', device.device_id)
        this.$bus.$emit('spotify-player-error', device)
      })

      window.player.addListener('player_state_changed', (status) => {
        this.checkPlaylist(status)
      })

      // Ready
      window.player.addListener('ready', (device) => {
        this.$bus.$emit('spotify-device-ready', device.device_id)
      })

      this.$bus.$on('spotify-player-previus', () => {
        this.playMusic(this.$spotifyTrackIndex == 0 ? this.$spotifyPlaylist.tracks.items.length - 1 : 0)
      })

      this.$bus.$on('spotify-player-next', () => {
        // window.player.nextTrack()
        const total = this.$spotifyPlaylist.tracks.items.length

        this.playMusic(this.$spotifyTrackIndex + 1 > total - 1 ? 0 : this.$spotifyTrackIndex + 1)
      })

      this.$bus.$on('spotify-player-resume', () => {
        window.player.resume()
      })

      this.$bus.$on('spotify-player-pause', () => {
        window.player.pause()
      })

      this.$bus.$on('spotify-playlist-follow', () => {
        this.$storage.set('spotifyFollow', 1)
        this.$spotify.followPlaylist(this.playlistUser, this.playlistId)
      })

      window.player.connect()
    },

    loadPlaylistTracks (page) {
      if (page === undefined) {
        page = 0
      }
      let limit = 100
      let offset = page * limit

      if (this.$spotifyPlaylist && this.$spotifyPlaylist.tracks && this.$spotifyPlaylist.tracks.total < (limit + offset)) {
        limit = this.$spotifyPlaylist.tracks.total - this.$spotifyPlaylist.tracks.items.length
      }

      this.$spotify.getPlaylistTracks(this.playlistUser, this.playlistId, { limit, offset }).then((data) => {
        for (let i in data.items) {
          this.$spotifyPlaylist.tracks.items.push(data.items[i])
        }

        if (this.$spotifyPlaylist.tracks.items.length === this.$spotifyPlaylist.tracks.total) {
          this.$set(this, '$spotifyPlaylist', this.$spotifyPlaylist)
        } else {
          this.loadPlaylistTracks(page + 1)
        }
      })
    },

    loadPlaylist (page) {
      this.$nextTick(() => {
        if (this.$storage.get('spotifyAccessToken') === null) {
          return
        }
        this.$spotify.getPlaylist(this.playlistUser, this.playlistId).then((data) => {
          this.$spotifyPlaylist = data
          if (data.tracks.next) {
            this.loadPlaylistTracks(1)
          }
          this.$set(this, '$spotifyPlaylist', this.$spotifyPlaylist)
        }, () => {
          this.$storage.remove('spotifyAccessToken')
          window.location.reload()
        })
      })
    },

    updateIndex (trackId) {
      let index = 0
      this.$spotifyPlaylist.tracks.items.forEach((item, itemIndex) => {
        if (item.track.id === trackId) {
          index = parseInt(itemIndex)
        }
      })
      if (parseInt(this.$storage.get('spotifyTrackIndex', 0)) !== index) {
        this.$storage.set('spotifyTrackIndex', index)
      }
    },

    checkPlaylist (status) {
      if (!status) {
        return
      }

      if (status.track_window && status.track_window.current_track) {
        this.updateIndex(status.track_window.current_track.id)
        this.$spotifyCurrentTrack = status.track_window.current_track
      }
      if (status.paused !== this.$spotifyPaused) {
        this.$spotifyPaused = status.paused
      }
      if (status.context.uri !== this.playlistUri) {
        this.playMusic()
      } else if (status && status.position) {
        this.$spotifyTrackPosition = status.position
      }
    },
    playMusic (trackIndex) {
      this.$spotify.setAccessToken(this.$storage.get('spotifyAccessToken'))
      
      if (trackIndex !== -1) {
        this.$spotifyTrackIndex = trackIndex
        this.$spotifyTrackPosition = 0
      }
      this.$spotify.play({
        device_id: window.player._options.id,
        context_uri: this.playlistUri,
        offset: {
          position: this.$spotifyTrackIndex
        }
      })
    }
  },
  mounted () {
    this.$bus.$on('spotify-player-play', (index) => {
      this.playMusic(index)
    })

    this.$bus.$on('spotify-device-ready', (deviceId) => {
      this.loadPlaylist()
      // this.playMusic()
    })

    this.$bus.$on('spotify-loadplaylist', (deviceId) => {
      this.loadPlaylist()
    })

    if (this.$storage.get('spotifyAccessToken') !== null) {
      this.loadPlaylist()
    }

    if (this.$spotifyReady) {
      this.mountPlayer()
    } else {
      this.$bus.$on('spotify-player-ready', () => {
        this.mountPlayer()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Spotify.vue